<template>
  <div v-for="(item, index) in items" :key="index" class="animated-menu">
    <transition enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp">
      <div
        v-if="activeItem === null || (activeItem !== null && activeItem.label === items[index].label)"
        v-bind="$attrs"
        :class="['animated-menu-item q-my-sm', `text-${color}`, `bg-${background}`, $attrs.class]"
        @click="updateActiveItem(activeItem !== null ? null : index)"
      >
        <section class="animated-menu-icon">
          <QIcon :name="item.icon" color="white" size="24px">
            <QBadge v-if="item.badge" class="animated-menu-icon-badge" floating color="red" rounded />
          </QIcon>
        </section>
        <section class="animated-menu-content">
          <div>
            {{ item.label }}
          </div>
        </section>
        <section class="animated-menu-state">
          <QIcon :name="activeItem !== null ? 'fas fa-minus' : 'fas fa-plus'" color="primary" size="18px" />
        </section>
      </div>
    </transition>
  </div>
</template>

<script setup>
  const emit = defineEmits(["action"]);
  const props = defineProps({
    items: {
      type: Array,
      default: () => [],
    },
    activeItem: {
      type: Object,
      default: () => null,
    },
    color: {
      type: String,
      default: "primary",
    },
    background: {
      type: String,
      default: "white",
    },
    shouldDisplayBadge: {
      type: Boolean,
      default: false,
    },
    notificationBadges: {
      type: Object,
      default: () => ({}),
    },
  });

  const updateActiveItem = function (index = null) {
    const selectedItem = index !== null ? props.items[index] : null;
    emit("action", selectedItem);
  };
</script>

<style lang="scss">
  .animated-menu {
    display: flex;
    flex-direction: column;
    width: 100%;
    .animated-menu-item {
      box-shadow: $card-shadow;
      background: white;
      border-radius: $generic-border-radius;
      display: inline-flex;
      width: 100%;
      position: relative;
      cursor: pointer;
      .animated-menu-icon,
      .animated-menu-content,
      .animated-menu-state {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 12px;
      }
      .animated-menu-icon {
        margin: -5px 0;
        height: 56px;
        border-radius: $md-border-radius;
        background-color: $primary;
      }
      .animated-menu-icon-badge {
        top: -20px;
        right: -15px;
      }

      .animated-menu-content {
        display: flex;
        align-items: center;
        justify-content: left;
        flex: 1;

        a {
          cursor: pointer;
          i {
            margin-right: 5px;
          }
          span {
            text-decoration: underline;
            margin-right: 10px;
          }

          @media screen and (max-width: 320px) {
            font-size: 0.9em;
          }
        }
      }
    }
  }
</style>
